import { BrowserRouter, Route, Routes, Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

import Login from "./page/Login";
import Signup from "./page/Signup";
import ForgetPassword from "./page/ForgetPassword";
import ResetPassword from "./page/ResetPassword";
import Home from "./page/Home";
import Player from "./page/Player";
import Language from "./page/Language";
import Profile from "./page/Profile";
import Search from "./page/Search";
import Success from "./page/Success";
import Fail from "./page/Fail";
import Checkout from "./page/Checkout";
import "./App.css";


function App(props) {
  let { token, isLogin } = useSelector((state) => state.auth);
  isLogin = isLogin === "true" || isLogin;
  return (
    <BrowserRouter>
      <div className="App">
        <Routes>
          <Route
            exact
            path="/login"
            element={isLogin ? <Navigate to="/home" /> : <Login />}
          />
          <Route
            exact
            path="/forgot-password"
            element={<ForgetPassword />}
          />
          <Route
            exact
            path="/reset-password/:token"
            element={<ResetPassword />}
          />
          <Route
            exact
            path="/signup"
            element={isLogin ? <Navigate to="/home" /> : <Signup />}
          />
          <Route
            exact
            path="/home/:id"
            element={token ? <Home /> : <Login />}
          />
          <Route
            exact
            path="/home"
            element={token ? <Home /> : <Login />}
          />
          <Route
            exact
            path="/category/:id"
            element={token ? <Home /> : <Login />}
          />
          <Route
            exact
            path="/player/:id/:type"
            element={token ? <Player /> : <Login />}
          />
          <Route
            exact
            path="/language"
            element={token ? <Language /> : <Login />}
          />
          <Route
            exact
            path="/profile"
            element={token ? <Profile /> : <Login />}
          />
          <Route
            exact
            path="/search"
            element={token ? <Search /> : <Login />}
          />
          <Route
            exact
            path="/success"
            element={<Success />}
          />
          <Route
            exact
            path="/fail"
            element={<Fail />}
          />
           <Route
            exact
            path="/checkout"
            element={token ? <Checkout /> : <Login />}
          />
          <Route
            path="/"
            element={isLogin ? <Home /> : <Navigate to="/login" />}
          >
            <Route path="*" element={<Navigate to="/" />} />
          </Route>
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
